import React, {useState} from 'react';

import {DrawerContentType} from '../WorkspaceDrawerContextProvider';
import {BackButton} from './components/BackButton';
import {useWorkspaceSettingOverrides} from './hooks/useSettingOverrides';
import {LinePlotSettings} from './runLinePlots/LinePlotSettings';
import {LinePlotSettingsContextProvider} from './runLinePlots/LinePlotSettingsContextProvider';
import {SelectedSettingType} from './types';
import {WorkspaceLayoutSettings} from './workspaceLayout/WorkspaceLayoutSettings';
import {useWorkspaceSettingsContext} from './WorkspaceSettingsContextProvider';
import {SettingsMenu} from './WorkspaceSettingsMenu';

export const WorkspaceSettingsContent = ({
  displayedContentType,
}: {
  displayedContentType: DrawerContentType;
}) => {
  return (
    <>
      <SettingComponent displayedContentType={displayedContentType} />
      {/* TODO - Add back in when we work on preview mode */}
      {/* <div
        className={twMerge(
          'flex h-[80px] w-[inherit]',
          'fixed bottom-0',
          'gap-24 px-24 py-20',
          'border-t-[1px] border-solid border-moon-250',
          '[&>*]:grow'
        )}>
        <Button
          variant="secondary"
          className="grow"
          onClick={closeWorkspaceDrawer}>
          Cancel
        </Button>
        <Button variant="primary" className="grow" disabled>
          Apply
        </Button>
      </div> */}
    </>
  );
};

const SettingComponent = ({
  displayedContentType,
}: {
  displayedContentType: DrawerContentType;
}) => {
  const {
    linePlot,
    trackWorkspaceSettingChange,
    updateLinePlotWorkspaceSettings,
  } = useWorkspaceSettingsContext();
  const {clearSetting, settingOverrideCounts} = useWorkspaceSettingOverrides();

  const [selectedSettingType, setSelectedSettingType] = useState<
    SelectedSettingType | undefined
  >();

  if (selectedSettingType == null) {
    return <SettingsMenu setSelectedSettingType={setSelectedSettingType} />;
  }

  if (selectedSettingType === 'workspace-layout') {
    return (
      <WorkspaceLayoutSettings
        setSelectedSettingType={setSelectedSettingType}
      />
    );
  }

  if (selectedSettingType === 'line-plot') {
    return (
      <LinePlotSettingsContextProvider
        clearSetting={clearSetting}
        displayLinePlotSettings={linePlot}
        settingLevel="workspace"
        settingOverrideCounts={settingOverrideCounts}
        trackLinePlotSetting={trackWorkspaceSettingChange}
        updateLinePlotSettings={updateLinePlotWorkspaceSettings}>
        <LinePlotSettings
          contentHeader={
            <BackButton onClick={() => setSelectedSettingType(undefined)} />
          }
          displayedContentType={displayedContentType}
        />
      </LinePlotSettingsContextProvider>
    );
  }

  return null;
};
